import { jsx } from "react/jsx-runtime";
import { isWeb } from "@tamagui/constants";
import { Children, cloneElement, isValidElement } from "react";
import { variableToString } from "../createVariable.js";
import { ThemeManagerContext } from "../helpers/ThemeManagerContext.js";
import { useServerRef } from "../hooks/useServerHooks.js";
import { useChangeThemeEffect } from "../hooks/useTheme.js";
function Theme(props) {
  if (props.disable)
    return props.children;
  const isRoot = !!props["_isRoot"];
  const themeState = useChangeThemeEffect(props, isRoot);
  const children = props["data-themeable"] ? Children.map(
    props.children,
    (child) => cloneElement(child, { ["data-themeable"]: true })
  ) : props.children;
  return useThemedChildren(themeState, children, props, isRoot);
}
function useThemedChildren(themeState, children, options, isRoot = false) {
  const { themeManager, isNewTheme, className, theme } = themeState;
  const { shallow, forceClassName } = options;
  const hasEverThemed = useServerRef(false);
  if (isNewTheme) {
    hasEverThemed.current = true;
  }
  if (isNewTheme || hasEverThemed.current || forceClassName || isRoot) {
    let next = Children.toArray(children);
    if (shallow && themeManager) {
      next = next.map((child) => {
        return isValidElement(child) ? cloneElement(
          child,
          void 0,
          /* @__PURE__ */ jsx(Theme, { name: themeManager.state.parentName, children: child.props.children })
        ) : child;
      });
    }
    const wrapped = /* @__PURE__ */ jsx(ThemeManagerContext.Provider, { value: themeManager, children: next });
    if (forceClassName === false) {
      return wrapped;
    }
    if (isWeb && !options.passPropsToChildren) {
      const themeColor = theme && isNewTheme ? variableToString(theme.color) : "";
      const colorStyle = {
        color: themeColor
      };
      return /* @__PURE__ */ jsx("span", { className: `${className || ""} _dsp_contents`, style: colorStyle, children: wrapped });
    }
    return wrapped;
  }
  return children;
}
export {
  Theme,
  useThemedChildren
};
//# sourceMappingURL=Theme.js.map
